// Types
import { RootState } from 'types/RootState.types';

// Config
import { isFeatureActive } from './configReducer';
import featureConstants from '@constants/featureConstants';

export const getConfigFeaturesSelector = (state: RootState) => state.config?.features;
export const getSessionWarningAfterTimeSelector = (state: RootState) => state.config?.sessionWarningAfterTime;
export const getGooglePayConfiguration = (state: RootState) => state.config?.googlePayConfiguration ?? {};
export const getPaymentMessageFeatureSelector = (state: RootState) =>
  state?.config?.features?.find((f) => f?.id === featureConstants.EMERGENCY_PAYMENT_PAGE_MESSAGE);
export const getConfirmationMessageFeatureSelector = (state: RootState) =>
  state?.config?.features?.find((f) => f?.id === featureConstants.EMERGENCY_ORDER_CONFIRMATION_MESSAGE);
export const getDeliveryMessageFeatureSelector = (state: RootState) =>
  state?.config?.features?.find((f) => f?.id === featureConstants.EMERGENCY_DELIVERY_PAGE_MESSAGE);
export const getClickAndCollectCutOffWindowInMinutesSelector = (state: RootState) =>
  state.config?.clickAndCollectCutOffWindowInMinutes;

// Feature Active Flags
export const isApoEnabledFeatureActive = (state: RootState) => isFeatureActive(state, featureConstants.APO_ENABLED);
export const isBasketOrderTotalAlwaysVisibleFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.BASKET_ORDER_TOTAL_ALWAYS_VISIBLE);
export const isConciseCardSecurityMessageFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.CONCISE_CARD_SECURITY_MESSAGE);
export const isFasterPaymentPageFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.FASTER_PAYMENT_PAGE);
export const isKlarnaPayIn30DaysFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.KLARNA_PAY_IN_30_DAYS);
export const isLowerAtraThresholdForGuestsTo220FeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.LOWER_ATRA_THRESHOLD_FOR_GUESTS_TO_220);
export const isSimplePhoneNumberFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.SIMPLE_PHONE_NUMBER);
export const isStreamlinedDeliveryMethodFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.STREAMLINED_DELIVERY_METHOD);
export const isStripeApplePayAlwaysEnabledFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.STRIPE_APPLE_PAY_ALWAYS_ENABLED);
export const isStripeCheckoutEnabledFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.STRIPE_CHECKOUT_ENABLED);
export const isStripeKlarnaCheckoutEnabledFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.STRIPE_KLARNA_CHECKOUT_ENABLED);
export const isReduceSavedCardCvvSkipFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.REDUCE_SAVED_CARD_CVV_SKIP);
